import { useState, useEffect, useRef, useMemo } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Tenants/TableForInActive";
import FilterModalForInActive from "../../Components/Tenants/FilterModalForInActive";
import { toast } from "react-toastify";
import {
  BoxTitle,
  BoxContainer,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapperWithSearch,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import moment from "moment";
import SummaryCard from "../../Components/Tenants/SummaryCardForInActive";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import NotFoundModel from "../../Components/NotFoundModel";
import SearchFilterBox from "../../Components/SearchFilterBox";
import DateRange from "../../Components/DateRange";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";
import SideModal from "../../Components/SideModal";
import { IoFilter } from "react-icons/io5";

const Tenants = () => {
  const searchOptions = [
    { label: "Mobile", value: 1 },
    { label: "Name", value: 2 },
  ];
  const user = useSelector((state) => state.UserReducer.user);
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );
  const [isFocused, setIsFocused] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const properties = useSelector((state) => state.PropertyReducer.property);
  const [selectedProperty, setSelectedProperty] = useState(property);
  const [selectedId, setSelectedId] = useState(null);

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [filter, setFilter] = useState("E");
  const [apiData, setApiData] = useState();
  const btnRef = useRef(null);
  const [summaryData, setSummaryData] = useState({
    totalMovedOut: 0,
    curMonthMovedOut: 0,
    defaulters: 0,
    totalDefaultedDues: 0,
    cancelledBooking: 0,
  });
  const [activeFilter, setActiveFilter] = useState({
    value: "",
    label: "",
    title: "",
  });

  const [startDate, setStartDate] = useState(
    sessionStorage.getItem("tenant_movedout_startDate") ||
    moment().subtract(6, 'months').startOf("month").format("YYYY-MM-DD")
  );

  const [endDate, setEndDate] = useState(
    sessionStorage.getItem("tenant_movedout_endDate") ||
    moment().format("YYYY-MM-DD")
  );

  const query = `startDate=${startDate}&endDate=${endDate}&propId=${selectedProperty?.id}&searchVal=${searchQuery}&t=${filterType}&filter=${filter}&platform=3`;

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/tenant/list/web?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.data === false) error = true;
    else {
      setApiData(res?.data?.list);
      setSummaryData(res?.data?.summary);
      setIsFocused(true);
    }
  };

  const getError = (res) => { };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
    isFetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  const queryParams = useMemo(() => ({
    startDate,
    endDate,
    propId: selectedProperty?.id,
    searchVal: searchQuery,
    t: filterType,
    filter,
    platform: 3,
  }), [startDate, endDate, selectedProperty, searchQuery, filterType, filter]);


  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
      setIsFocused(true);
    }, 150);

    return () => clearTimeout(handler);
  }, [queryParams, getListMutate]);


  useEffect(() => {
    if (startDate) sessionStorage.setItem("tenant_movedout_startDate", startDate);
    if (endDate) sessionStorage.setItem("tenant_movedout_endDate", endDate);
  }, [startDate, endDate]);


  // const filteredApiData = useMemo(() => {
  //   if (!apiData) return [];

  //   if (filter === "CB") {
  //     return apiData.filter(item => item.wasCancelled === 1);
  //   }

  //   return apiData;
  // }, [apiData, filter]);


  const submitHandler = (values) => {
    sessionStorage.removeItem("tenant_movedout_page");
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setSelectedId(null);
    setFilter("E");
    setFilterType("");
    setSearchQuery("");
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
  };

  const onSummaryBoxClick = (data) => {
    sessionStorage.removeItem("tenant_movedout_page");
    setFilter(data);
    setActiveFilter({ value: "", label: "", title: "" });
    setIsFilterOpen(false);
  };

  const downloadQuery = `&startDate=${startDate}&endDate=${endDate}&s=${searchQuery}&t=${filterType}&propId=${property?.id
    }&filter=${filter}&fileType=${1}&reportType=${10}`;
  const [reportUrl, setReportUrl] = useState();

  useEffect(() => {
    if (reportUrl) {
      const link = document.createElement("a");
      link.href = reportUrl;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setReportUrl(null);
    }
  }, [reportUrl]);

  const downloadFunction = async (values) => {
    const response = await axios.get(
      `${Config.apiUrl}/report/generate?${downloadQuery}`,
      {
        headers: {
          authorization: "Bearer " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const onDownloadSuccess = (res) => {
    if (res.isSuccess === false) {
      toast.error(res.msg || "No data found for the selected date range");
    } else if (res.reportUrl === false) {
      toast.error("No data found for the selected date range");
    } else {
      setReportUrl(res.reportUrl);
      toast.success(res.msg || "Report generated successfully");
    }
  };

  const onDownloadError = (res) => {
    toast.error(res.message || "Failed to download report");
  };

  const {
    mutate: downloadReport,
    isLoading: isDownloading,
  } = useMutation(downloadFunction, {
    onSuccess: onDownloadSuccess,
    onError: onDownloadError,
  });

  const handleFilterChange = (values) => {
    sessionStorage.removeItem("tenant_movedout_page");
    setFilter("E");
    setSelectedId(null);
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 200);
    // return () => {
    //   clearTimeout(handler);
    // };
  };

  const handleClearFilters = () => {
    sessionStorage.removeItem("tenant_movedout_page");
    setFilterType("");
    setSearchQuery("");
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 200);
    // return () => {
    //   clearTimeout(handler);
    // };
  };

  const handlePropertySelect = (property) => {
    setSelectedProperty(property);
  };

  const onApplyFilter = (value, label, title) => {
    sessionStorage.removeItem("tenant_movedout_page");
    setSelectedId(null);
    setFilter(value);
    setActiveFilter({ value, label, title });
    setIsFilterOpen(false);
  };

  const handleFilterClose = () => {
    setIsFilterOpen(false);
  };

  const handleClearFilter = () => {
    sessionStorage.removeItem("tenant_movedout_page");
    setFilter("E");
    setActiveFilter({ value: "", label: "", title: "" });
    setIsFilterOpen(false);
  };

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Moved Out
            <Underline />
          </BoxTitle>
          <DownloadBtn type="button" onClick={() => downloadReport()}>
            {isDownloading ? "Downloading..." : "Download"}
          </DownloadBtn>
        </BoxHead>

        <SideModal
          isOpen={isFilterOpen}
          onClose={() => setIsFilterOpen(false)}
        >
          <FilterModalForInActive
            setIsFilterOpen={setIsFilterOpen}
            onApplyFilter={onApplyFilter}
            selectedData={selectedData}
            handleClose={handleFilterClose}
            currentFilter={activeFilter.value}
            handleClearFilters={handleClearFilter}
          />
        </SideModal>

        {(isLoading || isRefetching) && !isFocused && (
          <SummarySkeletonLoading count={4} />
        )}

        {isFocused && apiData && (
          <SummaryCard summaryData={summaryData} onClick={onSummaryBoxClick} setSelectedId={setSelectedId} selectedId={selectedId} />
        )}

        <FilterTableWrapper>
          <FilterWrapperWithSearch>
            <div className="flex flex-col md:flex-row md:items-center gap-4">
              <SearchFilterBox
                options={searchOptions}
                handleFilterChange={handleFilterChange}
                handleClearFilters={handleClearFilters}
              />
              <DateRange
                submitHandler={submitHandler}
                defaultLabel={
                  moment(startDate).format("DD MMM yyyy") +
                  " - " +
                  moment(endDate).format("DD MMM yyyy")
                }
              />
            </div>
            <div className="flex gap-2 justify-end items-center">
              <PropertiesFilterDropdown
                properties={properties}
                selectedProperty={selectedProperty}
                onPropertySelect={handlePropertySelect}
                placeholder="Select Property"
                className="min-w-[200px] w-full md:w-[220px]"
              />
              <div className="relative">
                <FilterBtn
                  ref={btnRef}
                  type="button"
                  title="Tenant Filter"
                  onClick={() => setIsFilterOpen((v) => !v)}
                >
                  <IoFilter size={14} color="#9CA3AF" />
                  {activeFilter?.value && (
                    <span className="absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-yellow-500 border border-white" />
                  )}
                </FilterBtn>
              </div>
            </div>
          </FilterWrapperWithSearch>
          {!error && !isLoading && apiData && (
            <TableWrapper>
              <Table
                apiData={error ? [] : apiData?.length > 0 ? apiData : []}
                //apiData={error ? [] : filteredApiData}
                wasCancelled={filter}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
              />
              {(error || apiData?.length === 0) && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
        </FilterTableWrapper>
        {(isLoading || isRefetching) && <Loading />}
        {error && !isLoading && <NotFoundModel />}
      </BoxContainer>
    </>
  );
};


const TableWrapper = tw.h1`mt-4 bg-white rounded-md `;
const FilterBtn = tw.button`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto`;
const DownloadBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-primary-color flex space-x-1.5 justify-center items-center text-primary-color rounded-md px-6 cursor-pointer bg-white hover:bg-hover-color h-full py-2.5 text-sm`;

export default Tenants;
